import { computed, defineComponent, getCurrentInstance } from "vue";
import ModelColorPicker from "@/views/creative/model-editor/model-color-picker.vue";
import FormPanel from "@/views/creative/components/form-panel.vue";
import { ElSchemaFormItem } from "el-schema-form";
import ResetResource from "@/views/creative/components/reset-resource.vue";
export default defineComponent({
    components: {
        ResetResource: ResetResource,
        FormPanel: FormPanel,
        ModelColorPicker: ModelColorPicker,
        ElSchemaFormItem: ElSchemaFormItem
    },
    setup: function setup(props1) {
        var handleChange = function handleChange(param) {
            var prop = param.prop, value = param.value;
            var model = {};
            model[prop] = value;
            store.commit("creative/modelEditor/setShaderModel", model);
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var shaderModel = computed(function() {
            return store.state.creative.modelEditor.shaderModel;
        });
        var shaderList = computed(function() {
            var list = [
                {
                    title: root.$t("playTurbo.custom.modelEdit.appearance.mainColor"),
                    prop: "mainColor"
                },
                {
                    title: root.$t("playTurbo.custom.modelEdit.appearance.occlusion"),
                    prop: "occlusion",
                    formItem: {
                        prop: "occlusion",
                        component: "slider",
                        field: {
                            min: 0,
                            max: 1,
                            step: 0.01,
                            showTooltip: false
                        }
                    }
                },
                {
                    title: root.$t("playTurbo.custom.modelEdit.appearance.roughness"),
                    prop: "roughness",
                    formItem: {
                        prop: "roughness",
                        component: "slider",
                        field: {
                            min: 0,
                            max: 1,
                            step: 0.01,
                            showTooltip: false
                        }
                    }
                },
                {
                    title: root.$t("playTurbo.custom.modelEdit.appearance.metallic"),
                    prop: "metallic",
                    formItem: {
                        prop: "metallic",
                        component: "slider",
                        field: {
                            min: 0,
                            max: 1,
                            step: 0.01,
                            showTooltip: false
                        }
                    }
                },
                {
                    title: root.$t("playTurbo.custom.modelEdit.appearance.specularIntensity"),
                    prop: "specularIntensity",
                    formItem: {
                        prop: "specularIntensity",
                        component: "slider",
                        field: {
                            min: 0,
                            max: 1,
                            step: 0.01,
                            showTooltip: false
                        }
                    }
                },
                {
                    title: root.$t("playTurbo.custom.modelEdit.appearance.emissive"),
                    prop: "emissive"
                }, 
            ];
            var allowShowKeys = Object.keys(shaderModel.value);
            return list.filter(function(item) {
                return allowShowKeys.includes(item.prop);
            });
        });
        var isShowColorPicker = function(props) {
            return [
                "mainColor",
                "emissive"
            ].includes(props);
        };
        var handleReset = function(params) {
            store.dispatch("creative/modelEditor/resetShaderParamByKey", params.prop);
        };
        return {
            shaderModel: shaderModel,
            shaderList: shaderList,
            handleReset: handleReset,
            isShowColorPicker: isShowColorPicker,
            handleChange: handleChange
        };
    }
});
